export default __webpack_public_path__ + "static/media/Lesotho_logo_2.c3a2ed4f.png";